module.exports = __webpack_public_path__ + "static/img/img_4.b4b482c1.png";